(function (window) {
  'use strict';
  var prefix = '#ps-colors:';
  function trim(value) { return String(value || '').replace(/^\s+|\s+$/g, ''); }
  function pageNumber(value) { return /^[1-9][0-9]{0,2}$/.test(String(value)) ? parseInt(value, 10) : 0; }
  function decode(value) { return decodeURIComponent(String(value).replace(/\+/g, ' ')); }
  function readPage(location) {
    var parts = String(location.search || '').replace(/^\?/, '').split('&');
    var page = 1;
    var seen = false;
    var pair = [];
    var key = '';
    var i = 0;
    try {
      for (i = 0; i < parts.length; i++) {
        pair = parts[i].split('=');
        key = decode(pair.shift());
        if (key.toLowerCase() !== 'page') continue;
        if (key !== 'page' || seen) return 0;
        seen = true;
        page = pageNumber(decode(pair.join('=')));
      }
    } catch (_decodeError) { return 0; }
    return page;
  }
  function read(location) {
    var hash = String(location.hash || '');
    var state = { page: 1, query: '', year: '', model: '' };
    var seen = {};
    var parts = [];
    var pair = [];
    var key = '';
    var value = '';
    var i = 0;
    if (hash.indexOf(prefix) !== 0) return null;
    try {
      parts = hash.substring(prefix.length).split('&');
      for (i = 0; i < parts.length; i++) {
        pair = parts[i].split('=');
        key = decode(pair.shift());
        value = decode(pair.join('='));
        if (!/^(page|q|year|model)$/.test(key) || seen[key]) return { invalid: true };
        seen[key] = true;
        if (key === 'page') state.page = pageNumber(value);
        else state[key === 'q' ? 'query' : key] = trim(value);
      }
    } catch (_decodeError) { return { invalid: true }; }
    if (!state.page || (state.query && (state.query.length < 2 || state.query.length > 100))
      || (state.year && !/^[0-9]{4}$/.test(state.year)) || state.model.length > 100
      || /[\x00-\x1f\x7f]/.test(state.query + state.model)
      || !(state.query || state.year || state.model)) return { invalid: true };
    return state;
  }
  function href(location, page, state) {
    var query = [];
    var parts = String(location.search || '').replace(/^\?/, '').split('&');
    var key = '';
    var i = 0;
    var fragment = [];
    state = state || {};
    if (!pageNumber(page)) return '';
    for (i = 0; i < parts.length; i++) {
      try { key = decode(parts[i].split('=')[0]); } catch (_decodeError) { continue; }
      if (/^utm_[a-z0-9_]+$/i.test(key) || /^(fbclid|gclid|msclkid)$/i.test(key)) query.push(parts[i]);
    }
    if (state.query || state.year || state.model) {
      fragment.push('page=' + page);
      if (state.query) fragment.push('q=' + encodeURIComponent(state.query));
      if (state.year) fragment.push('year=' + encodeURIComponent(state.year));
      if (state.model) fragment.push('model=' + encodeURIComponent(state.model));
      if (read({ hash: prefix + fragment.join('&') }).invalid) return '';
    } else if (page > 1) query.push('page=' + page);
    return location.pathname + (query.length ? '?' + query.join('&') : '')
      + (fragment.length ? prefix + fragment.join('&') : '');
  }
  window.PSMakeColorNavigation = { read: read, readPage: readPage, href: href, pageNumber: pageNumber };
  // The native section owns two-tone results. Stop the older Router fallback writer.
  window.PSMakeTwoToneCompat = { active: true, native: true };
})(window);
